<template>
  <div class="pulse" :class="{'small': small}"></div>
</template>

<script>
export default {
  name: 'HotspotPulse',
  props: {
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

.pulse {
  height: 60px;
  width: 60px;
  border: 20px solid $c-white;
  box-shadow: 0 0 0 $c-white;
  border-radius: 90px;
  animation: pulse 2s $ease-out-quint infinite;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;

  &.small {
    height: 60px;
    width: 60px;
    border: 15px solid $c-white;
  }
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(0.1);
    opacity: 0;
    box-shadow: 0 0 0 $c-white;
  }

  60% {
    opacity: 0.3;
    box-shadow: 0 0 40px $c-white;
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
    box-shadow: 0 0 10px $c-white;
  }
}
</style>
